// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "auth/v1/auth.proto" (package "auth.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message auth.v1.IsKeyDefaultRequest
 */
export interface IsKeyDefaultRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message auth.v1.IsKeyDefaultResponse
 */
export interface IsKeyDefaultResponse {
    /**
     * @generated from protobuf field: bool is_default = 1;
     */
    isDefault: boolean;
}
/**
 * @generated from protobuf message auth.v1.SetOAuthLoginClientIDRequest
 */
export interface SetOAuthLoginClientIDRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string client_id = 2;
     */
    clientId: string;
}
/**
 * @generated from protobuf message auth.v1.SetOAuthLoginClientIDResponse
 */
export interface SetOAuthLoginClientIDResponse {
}
/**
 * @generated from protobuf message auth.v1.GetOAuthLoginClientIDRequest
 */
export interface GetOAuthLoginClientIDRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message auth.v1.GetOAuthLoginClientIDResponse
 */
export interface GetOAuthLoginClientIDResponse {
    /**
     * @generated from protobuf field: string client_id = 1;
     */
    clientId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class IsKeyDefaultRequest$Type extends MessageType<IsKeyDefaultRequest> {
    constructor() {
        super("auth.v1.IsKeyDefaultRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message auth.v1.IsKeyDefaultRequest
 */
export const IsKeyDefaultRequest = new IsKeyDefaultRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsKeyDefaultResponse$Type extends MessageType<IsKeyDefaultResponse> {
    constructor() {
        super("auth.v1.IsKeyDefaultResponse", [
            { no: 1, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message auth.v1.IsKeyDefaultResponse
 */
export const IsKeyDefaultResponse = new IsKeyDefaultResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetOAuthLoginClientIDRequest$Type extends MessageType<SetOAuthLoginClientIDRequest> {
    constructor() {
        super("auth.v1.SetOAuthLoginClientIDRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message auth.v1.SetOAuthLoginClientIDRequest
 */
export const SetOAuthLoginClientIDRequest = new SetOAuthLoginClientIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetOAuthLoginClientIDResponse$Type extends MessageType<SetOAuthLoginClientIDResponse> {
    constructor() {
        super("auth.v1.SetOAuthLoginClientIDResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message auth.v1.SetOAuthLoginClientIDResponse
 */
export const SetOAuthLoginClientIDResponse = new SetOAuthLoginClientIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOAuthLoginClientIDRequest$Type extends MessageType<GetOAuthLoginClientIDRequest> {
    constructor() {
        super("auth.v1.GetOAuthLoginClientIDRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message auth.v1.GetOAuthLoginClientIDRequest
 */
export const GetOAuthLoginClientIDRequest = new GetOAuthLoginClientIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOAuthLoginClientIDResponse$Type extends MessageType<GetOAuthLoginClientIDResponse> {
    constructor() {
        super("auth.v1.GetOAuthLoginClientIDResponse", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message auth.v1.GetOAuthLoginClientIDResponse
 */
export const GetOAuthLoginClientIDResponse = new GetOAuthLoginClientIDResponse$Type();
/**
 * @generated ServiceType for protobuf service auth.v1.InternalAuthService
 */
export const InternalAuthService = new ServiceType("auth.v1.InternalAuthService", [
    { name: "IsKeyDefault", options: {}, I: IsKeyDefaultRequest, O: IsKeyDefaultResponse },
    { name: "SetOAuthLoginClientID", options: {}, I: SetOAuthLoginClientIDRequest, O: SetOAuthLoginClientIDResponse },
    { name: "GetOAuthLoginClientID", options: {}, I: GetOAuthLoginClientIDRequest, O: GetOAuthLoginClientIDResponse }
]);
